import React, { PropsWithChildren } from 'react';

const InputInfo = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
  return <small className="omnipresent">{children}</small>;
};

export default InputInfo;
